import React from 'react';
import {Field} from 'formik';
type Props = {
	statusOptions: {label: string; value: string}[];
	label: string;
	value: string;
	fieldName: string;
};
const FilterByStatus: React.FC<Props> = ({
	statusOptions,
	label,
	value,
	fieldName,
}) => {
	return (
		<div className="form-filter__item form-filter__item-select2">
			<div className="item-select2__label">{label}</div>
			<Field
				className="form-filter__select2"
				name={fieldName}
				as={'select'}
				value={value}
			>
				{statusOptions.map((option) => (
					<option key={option.value} value={option.value}>
						{option.label}
					</option>
				))}
			</Field>
		</div>
	);
};

export default FilterByStatus;
